module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/root/root.component.html
// module id = ../../../../../src/app/components/root/root.component.html
// module chunks = main